import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { operatorName } from '../../../config/operator';
import useBasketContext from '../../../contexts/basket/useBasketContext';
import useDeliveryVenueContext from '../../../contexts/delivery-venue/useDeliveryVenueContext';
import useOperatorContext from '../../../contexts/operator/useOperatorContext';
import useSiteContext from '../../../contexts/site/useSiteContext';

// What arriving at the start of an order does, however the page lays out the choice of where to order from:
// it forgets any order in progress and fetches the sites and delivery venues to choose from.
const useChannelSelectSetup = () => {
    const operatorContext = useOperatorContext();
    const siteContext = useSiteContext();
    const deliveryVenueContext = useDeliveryVenueContext();
    const basketContext = useBasketContext();

    // Google Ordering conversion tracking
    const cookieDomain = window.location.host.split('.').slice(1).join('.');
    const [searchParams] = useSearchParams();

    useEffect(() => {
        // Google Ordering conversion tracking
        const rwgToken = searchParams.get('rwg_token');

        if (rwgToken) {
            document.cookie = `__Secure-_rwgToken=${rwgToken}; domain=${cookieDomain}; path=/; max-age=2592000; samesite=lax; secure`;
            document.cookie = `__Secure-_rwgMerchantId=${operatorContext.operator?.handle}; domain=${cookieDomain}; path=/; max-age=2592000; samesite=lax; secure`;
        }

        basketContext.clearBasket();
        localStorage.removeItem('postcode');
        localStorage.removeItem('delivery-venue');
        localStorage.removeItem('table');

        if (siteContext) {
            let flow = operatorContext.operator?.flow ?? 'noflow';
            siteContext.fetchSites(operatorName, flow);
        } else {
            console.warn('Skipped fetch site call.');
        }

        if (deliveryVenueContext) {
            let flow = operatorContext.operator?.flow ?? 'noflow';
            deliveryVenueContext.fetchDeliveryVenues(operatorName, flow);
        } else {
            console.warn('Skipped fetch delivery venue call.');
        }
    }, []);
};

export default useChannelSelectSetup;
